import React from 'react';

interface LeaderBoardIconProps {
  className?: string;
}

export const LeaderBoardIcon: React.FC<LeaderBoardIconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M5.25688 8V13.623C5.25688 13.8556 5.16892 14.0787 5.01236 14.2431C4.85579 14.4076 4.64344 14.5 4.42202 14.5H2.33486C2.11344 14.5 1.90109 14.4076 1.74453 14.2431C1.58796 14.0787 1.5 13.8556 1.5 13.623V8C1.5 7.76741 1.58796 7.54434 1.74453 7.37988C1.90109 7.21541 2.11344 7.12302 2.33486 7.12302H4.42202C4.64344 7.12302 4.85579 7.21541 5.01236 7.37988C5.16892 7.54434 5.25688 7.76741 5.25688 8ZM9.01376 1.5H6.92661C6.70519 1.5 6.49284 1.5924 6.33627 1.75686C6.1797 1.92133 6.09174 2.14439 6.09174 2.37698V13.623C6.09174 13.8556 6.1797 14.0787 6.33627 14.2431C6.49284 14.4076 6.70519 14.5 6.92661 14.5H9.01376C9.23518 14.5 9.44753 14.4076 9.6041 14.2431C9.76066 14.0787 9.84862 13.8556 9.84862 13.623V2.37698C9.84862 2.14439 9.76066 1.92133 9.6041 1.75686C9.44753 1.5924 9.23518 1.5 9.01376 1.5Z"
        fill="currentColor"
      />
      <path
        d="M11.578 3.97619H13.6651C13.8866 3.97619 14.0989 4.06859 14.2555 4.23305C14.412 4.39752 14.5 4.62058 14.5 4.85317V13.623C14.5 13.8556 14.412 14.0787 14.2555 14.2431C14.0989 14.4076 13.8866 14.5 13.6651 14.5H11.578C11.3566 14.5 11.1442 14.4076 10.9876 14.2431C10.8311 14.0787 10.7431 13.8556 10.7431 13.623V4.85317C10.7431 4.62058 10.8311 4.39752 10.9876 4.23305C11.1442 4.06859 11.3566 3.97619 11.578 3.97619Z"
        fill="currentColor"
      />
    </svg>
  );
};
